module.exports = __webpack_public_path__ + "img/4.23ebfcb9.jpg";